export const buildResidentialPayload = (form, companyId, payloadId) => {
  const num = (v, d = 0) =>
    v === undefined || v === "" || v === null ? d : Number(v);
  const bool = (v) => !!v;

  const hasCoords =
    form.latitude !== undefined &&
    form.longitude !== undefined &&
    form.latitude !== "" &&
    form.longitude !== "";

  const payload = {
    type: "residencial",
    companyId: Number(companyId),
    payload: {
      workTypeServiceId: Number(payloadId),
      sqft: num(form.squareFt),
      config: {
        ...(hasCoords
          ? {
              coverageArea: {
                coordinates: {
                  latitude: Number(form.latitude),
                  longitude: Number(form.longitude),
                },
              },
            }
          : {}),
        rooms: {
          masterBedroom: num(form.masterBedroom ?? form.totalBedrooms),
          otherRoom: num(form.otherRoom ?? form.otherRooms),
          masterBathroom: num(form.masterBathroom ?? form.masterBathrooms),
          regularBathroom: num(form.regularBathroom ?? form.regularBathrooms),
          halfBathroom: num(form.halfBathroom ?? form.halfBathrooms),
        },
        areas: {
          kitchen: bool(form.kitchen),
          livingRoom: bool(form.livingRoom),
          laundryRoom: bool(form.laundryRoom),
          stairs: bool(form.stairs),
        },
        additionalRequest: {
          fridge: bool(form.fridge ?? form.fridgeInteriorCleaning),
          dishwasher: bool(form.dishwasher ?? form.fillAndRunDishwasher),
          tidyUp: bool(form.tidyUp),
          windows: bool(form.windows ?? form.windowInteriorCleaning),
          oven: bool(form.oven ?? form.ovenInteriorCleaning),
          handDishwashing: bool(form.handDishwashing ?? form.handDishWashing),
          garage: bool(form.garage ?? form.garageCleaning),
        },
        hasPets: bool(form.havePets ?? form.hasPets),
        ...(form.averagePeople !== undefined && form.averagePeople !== ""
          ? { averagePeople: Number(form.averagePeople) }
          : {}),
      },
    },
  };

  if (hasCoords) {
    const extraMilesRate = num(form.surchargeValue);   
    const extraMiles = num(form.extraDistanceMiles);   
    const ignoredAreaRate = num(form.ignoredAreaRate); 

    // Prioridad:
    if (form.inIgnoreArea && ignoredAreaRate > 0) {
      payload.payload.config.coverageArea.surcharge = {
        type: "miles",
        ignoredAreaRate,
      };
    } else if (!form.inCoverage && extraMiles > 0 && extraMilesRate > 0) {
      payload.payload.config.coverageArea.surcharge = {
        type: "miles",
        extraMilesRate,
      };
    }
  }

  return payload;
};
